import { IServerResponse } from "@/api/types";
import { API_BROKERS_URL } from "@/configs/global";
import { AxiosResponse } from "axios";
import { axiosInstance } from "@/api/index";
import { BrokerPair, BrokerReport, BrokerReportFilters } from "@/api/types/broker";
import { FormattedItem } from "@/utils/CellsFromBff";

export async function getBrokerPairs(): Promise<IServerResponse<BrokerPair[]>> {
    return axiosInstance.request<IServerResponse<BrokerPair[]>>({
        method: 'GET',
        url: `${API_BROKERS_URL}/pairs`,
    })
        .then((response: AxiosResponse<IServerResponse<BrokerPair[]>>) => response.data);
}

type BrokerReportType = IServerResponse<FormattedItem<BrokerReport>[]>
export async function getBrokerReport(params: BrokerReportFilters, isExport?: boolean): Promise<BrokerReportType> {
    const headers = isExport ? { 'Accept': "text/csv" } : {};
    return axiosInstance.request<BrokerReportType>({
        method: 'GET',
        url: `${API_BROKERS_URL}/report`,
        params,
        headers,
    })
        .then((response: AxiosResponse<BrokerReportType>) => response.data);
}
